import React from 'react';
import './Copies.scss';
import eioLogo from '../../assets/EIOLogo.png';
import pfizerBlue from '../../assets/pfizer-logo.png';

function Copy8() {
  return (
    <section className="copies marginTopAdd">
      <p className="italicP">
        World Atopic Eczema Day is a great time to reach out, find resources, and know that you’re
        not alone. For more information on eczema and resources on finding support,{' '}
        <a
          href="https://www.pfizer.com/news/media-resources/press-kits/eczema-media-kit"
          target="_blank"
          rel="sponsored noopener"
          style={{ color: '#0000c9', textDecoration: 'underline' }}
        >
          click here.
        </a>
      </p>
      <div className="eioCont">
        <img src={pfizerBlue} alt="pfizer colored logo" />
        <img src={eioLogo} className="eioLogo" alt="EIO logo" />
      </div>
    </section>
  );
}

export default Copy8;
